import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import helperNumbers from "../../../helpers/numbers";
import helperMobile from "../../../helpers/mobile";
import helpersTime from "../../../helpers/time";
import httpService from "../../../services/httpServices/httpServices";
import { Link } from "react-router-dom";
import Pagination from "../../partials/content/Pagination";

export default function AllUserRegisteredByMarketer() {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  const [firstNameUserSearch, setFirstNameUserSearch] = useState();
  const [lastNameUserSearch, setLastNameUserSearch] = useState();
  const [userIDSearch, setUserIDSearch] = useState();

  useEffect(() => {
    getUsers();
  }, [
    currentPage,
    countItemPerPage,
    firstNameUserSearch,
    lastNameUserSearch,
    userIDSearch,
  ]);

  const getUsers = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const users = await sendRequestGetUser(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!users) {
      return;
    }

    setUsers(users.users_marketer);
    setCountPage(users.count_page);
  };

  const sendRequestGetUser = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let users;
    try {
      users = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/users?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return users.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateDoNotHaveUsers = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img class="img-fluid" src="/assets/img/do-not-have-campaigns.svg" />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p> شما در حال حاضر هیچ کاربری ندارید :(</p>
          <p>برای شروع کار یک کاربر بسازید.</p>
          <div className="text-center text-md-right pt-2">
            <Link className="btn btn-success" to="/marketer/add-user">
              <i className="fa fa-plus ml-1"></i>
              اضافه کردن کاربر
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (firstNameUserSearch) {
      searchFilterQuery = `${searchFilterQuery}&first_name=${firstNameUserSearch}`;
    }
    if (lastNameUserSearch) {
      searchFilterQuery = `${searchFilterQuery}&last_name=${lastNameUserSearch}`;
    }
    if (userIDSearch) {
      searchFilterQuery = `${searchFilterQuery}&user_id=${userIDSearch}`;
    }

    return searchFilterQuery;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateUsersTable = () => {
    return (
      <>
        <div className="pb-2">
          <Link to="/marketer/add-user" className="btn btn-success">
            <span className="pl-2">
              <i className="fa fa-plus"></i>
            </span>
            <span>اضافه کردن کاربر </span>
          </Link>
        </div>
        <div class="container-fluid">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 ">
              <label>جستجو کاربر</label>
              <hr />
            </div>
            <div class="col-12 col-md-3">
              <div>
                <label>شماره کاربر</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="number"
                  onWheel={(event) => event.currentTarget.blur()}
                  onKeyUp={(e) => setUserIDSearch(e.target.value)}
                />
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div>
                <label>نام کاربر</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  onKeyUp={(e) => setFirstNameUserSearch(e.target.value)}
                />
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div>
                <label>نام خانوادگی کاربر</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  onKeyUp={(e) => setLastNameUserSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره کاربر</td>
                <td>نام</td>
                <td>نام خانوادگی</td>
                <td>ایمیل</td>
                <td>شماره موبایل</td>
                <td>تاریخ ایجاد</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => {
                return (
                  <tr key={index}>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td>{helperNumbers.toPersianNum(user.user_id)}</td>
                    <td>{user.first_name}</td>
                    <td>{user.last_name}</td>
                    <td>{user.email}</td>
                    <td>
                      <span dir="ltr">
                        {helperNumbers.toPersianNum(
                          helperMobile.formatMobile(user.mobile)
                        )}
                      </span>
                    </td>
                    <td>
                      {helperNumbers.toPersianNum(
                        helpersTime.convertGregorianToJalali(user.created_at) +
                          " " +
                          user.created_at.split(" ")[1]
                      )}
                    </td>
                    <td>
                      <span className="pl-2">
                        <Link
                          className="btn btn-info"
                          to={`/marketer/view-all-payment/${user.user_id}`}
                        >
                          لیست پرداخت کاربران
                        </Link>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 && generatePagination()}
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="users-marketer" activeItem="all-user-marketer" />

      <div className="content-wrapper">
        <TitleBar title="لیست کاربران" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {users.length == 0 &&
              firstNameUserSearch == null &&
              lastNameUserSearch == null &&
              userIDSearch == null
                ? generateDoNotHaveUsers()
                : generateUsersTable()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
